var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('ul',[_c('li',{on:{"click":_vm.MainRouter}},[_vm._v("로그아웃")]),_c('li',{on:{"click":_vm.AddcarRouter}},[_vm._v("마이페이지")]),_c('li',{on:{"click":_vm.SitemapRouter}},[_vm._v("사이트맵")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }